import React, { useEffect } from 'react';
import './new.css';
import { Link } from 'react-router-dom';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import Cosection from '../components/Cosections';

export const Bookkeeping = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <NavBar />
      <div className="tax-page">
        <div className="tax-notification-container">
          <div className="tax-notification">
            <div className="tax-notification-glow"></div>
            <div className="tax-notification-border-glow"></div>
            <h1 className="tax-notification-title">
              Accounting and Bookkeeping Services
            </h1>
            <Link to="/services" className="tax-notification-body">
              ← Back to Business Services
            </Link>
          </div>
        </div>

        <div className="tax-content-container">
          <h1 className="tax-section-title">
            Professional Accounting and Bookkeeping with Easy Tax Experts 
          </h1>
          <p className="tax-section-description">
            Staying on top of your books shouldn’t feel overwhelming. Whether
            you’re a small business owner, startup founder, or established
            enterprise, <strong>Easy Tax Experts </strong> helps you keep your
            financial records accurate, compliant, and future-ready. Our team of
            CPAs and EAs combine proven accounting expertise with the latest
            cloud technologies to give you clear insights and peace of mind.
          </p>

          <h2 className="tax-subheading">Why Businesses Trust Our Services</h2>
          <ul className="tax-section-description">
            <li>
              <strong>Certified Expertise:</strong> Work with licensed CPAs and
              EAs who understand U.S. GAAP, IRS compliance, and state-level
              regulations.
            </li>
            <li>
              <strong>Time & Cost Savings:</strong> Free yourself from tedious
              data entry and reconciliations so you can focus on growth.
            </li>
            <li>
              <strong>Tailored Solutions:</strong> From e-commerce to
              professional services, we adapt our processes to your industry.
            </li>
            <li>
              <strong>Cloud-Powered Efficiency:</strong> Real-time dashboards,
              secure document sharing, and automated workflows for accuracy and
              speed.
            </li>
          </ul>

          <h2 className="tax-subheading">
            Our Accounting & Bookkeeping Solutions
          </h2>
          <ol className="tax-section-description">
            <li>
              <strong>System Setup & Migration:</strong> Implementation and
              transition to QuickBooks, Xero, or other platforms tailored to
              your needs.
            </li>
            <li>
              <strong>Day-to-Day Bookkeeping:</strong> Recording income,
              expenses, accounts payable/receivable, and payroll processing.
            </li>
            <li>
              <strong>Bank & Account Reconciliation:</strong> Ensuring your
              books match your statements, detecting discrepancies quickly.
            </li>
            <li>
              <strong>Financial Reporting:</strong> Timely balance sheets,
              income statements, and cash flow reports for smarter decisions.
            </li>
            <li>
              <strong>Tax-Ready Books:</strong> Organized records to simplify
              business tax return preparation and minimize IRS risks.
            </li>
            <li>
              <strong>Budgeting & Forecasting:</strong> Practical roadmaps to
              manage cash flow, prepare for investments, and scale operations.
            </li>
            <li>
              <strong>Year-End Closings:</strong> Streamlined reports and
              reconciliations to prepare your business for tax season and
              audits.
            </li>
            <li>
              <strong>Advisory & Consulting:</strong> Strategic insights on cost
              control, profit improvement, and operational efficiency.
            </li>
          </ol>

          <h2 className="tax-subheading">Industries We Serve</h2>
          <p className="tax-section-description">
            We work with startups, freelancers, family-owned businesses, and
            fast-growing enterprises across industries like retail, IT services,
            logistics, and healthcare. Our flexible solutions grow with your
            business.
          </p>

          <h2 className="tax-subheading">Let’s Build Stronger Financials</h2>
          <p className="tax-section-description">
            At <strong>Easy Tax Experts </strong>, accounting isn’t just about
            compliance—it’s about clarity, strategy, and growth. With us
            handling your books, you’ll always know where your business stands
            financially and where it’s headed. <br />
            <br />
            <strong>Ready to simplify your bookkeeping?</strong> Contact us
            today and partner with a team that helps you make smarter financial
            decisions.
          </p>
        </div>
      </div>
      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default Bookkeeping;
